
    import { defineComponent } from 'vue'
    import ListAdd from './ListAdd.vue'

    export default defineComponent({
        props: {
            index: Number,

        },
        components: {
            ListAdd,

        },
        data() {
            return {
                showInput: false,

            }
        },
        computed: {

        },
        methods: {
            add(val: string) {
                this.$emit('add', val)
                this.showInput = false
            },
        },
    })

    